import clsx from 'clsx';
import type { HTMLAttributes } from 'react';

import { bg, card, content } from './believer-card.css';

export const BelieverCard = ({
  children,
  type,
  className,
  ...attrs
}: HTMLAttributes<HTMLDivElement> & {
  type: 1 | 2;
}) => {
  return (
    <div className={clsx(card, className)} data-type={type} {...attrs}>
      <div className={bg} aria-hidden="true">
        <GoldllenIcon
          width={220}
          height={220}
          style={{
            position: 'absolute',
            right: -24,
            bottom: -36,
            opacity: 0.08,
          }}
        />
      </div>
      <div className={content}>{children}</div>
    </div>
  );
};
import { GoldllenIcon } from '@affine/component/brand';
